import BaseStore from '@src/utils/store/base-store';
import NaviBarStore from '../../business-components/navibar/store';
import message from '@src/components/common-message';
import { reaction } from 'mobx';
import { useMount, useRequest } from 'ahooks';
import { noop } from '@src/utils/common-util';
import { useEffect } from 'react';

class BaseLayoutStore extends BaseStore {
  naviBarStore = new NaviBarStore();

  executeGWConfig = noop;

  // 获取官网信息
  getGWConfig = async () => {
    return this.$ztService.gwConfig();
  };

  // 信息获取成功回调
  onGWConfigSuccess = data => {
    // 公测环境配置修改：https://ucenter.seasungame.com/user/login?response_type=code&client_id=zt_ws_test&state=647861&force=true
    const { account = null, is_in_subscribe_code_time = -1, is_in_open_download_time = -1, is_game_open_get_code_status = -1, total } = data;
    this.$globalStore.inDownloadTime = is_in_open_download_time;
    this.$globalStore.isInSubscribeCodeTime = is_in_subscribe_code_time;
    this.$globalStore.downLoadGetCodeStatus = is_game_open_get_code_status;
    this.$globalStore.appointmentCount = total;

    this.$globalStore.authServise.setAccountInfo(account);
  };

  use() {
    super.use();

    this.executeGWConfig = useRequest(async () => await this.getGWConfig(), {
      manual: true,
      onSuccess: this.onGWConfigSuccess,
      onError: e => {
        e.serviceResponse?.message && message.error(e.serviceResponse?.message);
      }
    });

    // 海外统一使用
    useEffect(
      () => {
        if (window.XPASS?.$accountStore.loginStatus && this.$globalStore.inDownloadTime) {
          this.$globalStore.authServise?.setAccountInfo?.(window.XPASS?.$accountStore?.name);
        }
      },
      [
        window.XPASS?.$accountStore.loginStatus,
        this.$globalStore.inDownloadTime,
        window.XPASS?.$accountStore?.desensitizationEmail,
        window.XPASS?.$accountStore?.passportId
      ]
    );

    useMount(async () => {
      reaction(
        () => [this.$globalStore.navbarStick],
        () => {
          this.naviBarStore.isSticky = this.$globalStore.navbarStick;
        },
        {
          fireImmediately: true
        }
      );
      // 获取官网信息
      // await this.executeGWConfig.run();
    });
  }
}

export default BaseLayoutStore;
